import JSZip from "jszip";
import { toast } from "sonner";

export const downloadFileBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url, {
    method: "GET",
    credentials: "omit",
  });
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }
  return response.blob();
};

export const downloadReferencesZipFile = async (
  files: { name: string; url: string }[],
) => {
  try {
    const zip = new JSZip();
    const failedFiles: string[] = [];

    await Promise.all(
      files.map(async (file) => {
        try {
          const blob = await downloadFileBlob(file.url);
          zip.file(file.name, blob);
        } catch (error) {
          console.error("Attachment download failed", {
            name: file.name,
            url: file.url,
            error,
          });
          failedFiles.push(file.name);
        }
      }),
    );

    if (Object.keys(zip.files).length === 0) {
      throw new Error("Could not download attachments.");
    }

    const content = await zip.generateAsync({ type: "blob" });

    const url = window.URL.createObjectURL(content);
    const a = document.createElement("a");
    a.href = url;
    a.download = "references.zip";

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    if (failedFiles.length > 0) {
      toast.warning(`Failed to download ${failedFiles.length} file(s).`);
    }
  } catch (err) {
    toast.error(`Download failed: ${(err as Error).message}`);
  }
};

export const downloadIndividualFile = async (name: string, url: string) => {
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    toast.error(`Failed to download ${name}`);
    console.error("Failed to download file", error);
  }
};
